/** Shown in the assistant bubble while the chat API request is in flight. */
export const ASSISTANT_PENDING_TEXT = 'Thinking…'

export function isPendingAssistantText(text) {
  return text === ASSISTANT_PENDING_TEXT
}

/** @param {{ text?: string, demoStreamActive?: boolean }} assistant */
export function isAssistantAnswerLoading(assistant) {
  if (isPendingAssistantText(assistant.text ?? '')) return true
  return Boolean(assistant.demoStreamActive)
}

/** @param {{ text?: string, demoStreamActive?: boolean, blocks?: unknown[] }} assistant */
export function isAssistantContentReady(assistant) {
  if (isAssistantAnswerLoading(assistant)) return false
  if (Array.isArray(assistant.blocks) && assistant.blocks.length > 0) return true
  return Boolean(String(assistant.text ?? '').trim())
}

/** @param {{ text?: string, demoStreamActive?: boolean, blocks?: unknown[] }} assistant */
export function shouldShowAssistantMessageActions(assistant) {
  return isAssistantContentReady(assistant) && !isAssistantAnswerLoading(assistant)
}
